// ServicesGrid.tsx
import React from "react";

//@ts-ignore
import cat1 from "../assets/images/consultanta.jpg";
//@ts-ignore
import cat2 from "../assets/images/programare.jpg";
//@ts-ignore
import cat3 from "../assets/images/montaj.jpg";
//@ts-ignore
import cat4 from "../assets/images/proiectare.jpg";
//@ts-ignore
import cat5 from "../assets/images/automatizari.jpg";
//@ts-ignore
import cat6 from "../assets/images/model.jpg";

type ServiceItem = {
  title: string;
  description: string;
  image: string; // url to background image
  href?: string;
  alt?: string;
};

const services: ServiceItem[] = [
  {
    title: "CONSULTANȚĂ & PROIECTARE",
    description:
      "Ascultăm nevoile tale și analizăm spațiul pentru a crea un proiect personalizat. Fiecare detaliu este gândit pentru a-ți aduce maximum de confort, siguranță și eficiență energetică.",
    image: cat1,
    href: "/servicii/consultanta-si-proiectare",
    alt: "Consultanță și proiectare pentru case inteligente în Cluj, oferită de un specialist Asempera în fața planului de automatizare.",
  },
  {
    title: "PROGRAMARE & INTEGRARE",
    description:
      "Prin configurarea Loxone, facem ca toate sistemele casei tale (lumini, climatizare, securitae, audio) să funcționeze ca un singur sistem, perfect sincronizat pentru confortul tău",
    image: cat2,
    href: "/servicii/programare-si-integrare",
    alt: "Aplicație de control pentru o casă inteligentă, demonstrând integrarea sistemelor de lumini și climatizare după programarea Loxone.",
  },
  {
    title: "MONTAJ & PUNERE ÎN FUNCȚIUNE",
    description:
      "Echipa noastră instalează fiecare componentă cu precizie și atenție la detalii. la final, testăm întregul sistem pentru a ne asigura că funcționează perfect încă din prima zi.",
    image: cat3,
    href: "/servicii/montaj",
    alt: "Tehnician Asempera realizând montajul unui sistem smart home în Cluj-Napoca, cu atenție la detalii.",
  },
  {
    title: "CLĂDIRI INTELIGENTE",
    description:
      "Implementăm sisteme de automatizare avansate pentru birouri, hoteluri și spații comerciale, oferind un management centralizat al tuturor funcțiilor: de la climatizare și iluminat, până la securitate și control acces.",
    image: cat4,
    href: "/servicii/cladiri-inteligente",
    alt: "Clădire comercială inteligentă cu sistem de iluminat și management centralizat al clădirii, soluție Asempera.",
  },
  {
    title: "AUTOMATIZĂRI INDUSTRIALE",
    description:
      "Cu o experiență de peste 20 de ani în domeniu, suntem partenerul de încredere pentru soluții de automatizări industriale. Misiunea noastră este să optimizăm procesele tale, crescând eficiența, fiabilitatea și productivitatea prin tehnologie de ultimă generație și expertiză dovedită",
    image: cat5,
    href: "/servicii/automatizari",
  },
  {
    title: "MODELHOME LOXONE CLUJ-NAPOCA",
    description:
      "Cea mai bună metodă de a înțelege puterea unui sistem Loxone este să îl experimentezi. Te invităm în showroom-ul nostru din Cluj-Napoca să simți confortul unei case inteligente. Programează o vizită și descoperă viitorul.",
    image: cat6,
    href: "/servicii/modelhome",
    alt: "Living modern în showroom-ul Loxone din Cluj-Napoca, echipat cu sisteme de iluminat și umbrire inteligente.",
  },
];

export default function ServicesGrid() {
  return (
    <section className="services-section">
      <div className="services-wrapper">
        {services.map((s, i) => {
          const Card = s.href ? "a" : "div";
          return (
            <Card
              key={i}
              className="service-card"
              href={s.href as string | undefined}
              style={{ backgroundImage: `url(${s.image})` }}
              aria-label={s.alt}
            >
              <div className="shade" />
              <div className="content">
                <h3 className="title">{s.title}</h3>
                <p className="description">{s.description}</p>
                {s.href && <span className="more">Vezi detalii →</span>}
              </div>
            </Card>
          );
        })}
      </div>
    </section>
  );
}
